import React from 'react';
import './blog-post.css';

import f1 from './pictures/f1.jpg';
import f2 from './pictures/f2.jpg';
import f3 from './pictures/f3.jpg';
import f4 from './pictures/f4.jpg';
import f5 from './pictures/f5.jpg';
import f6 from './pictures/f6.jpg';

//import reportWebVitals from './reportWebVitals';

const Friendsgiving = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Friendsgiving Recap</h2>
                    <p class="site-post-meta">November 17th, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Thank you for coming to our Friendsgiving last Friday! 
                    It was wonderful to see so many people attend. 
                    We all had fun watching Gilmore Girls, playing board games, 
                    and meeting new people!
                    <br></br>
                     
                    </p>
                    <img src={f1} alt="WiC Officers"/>
                    <img src={f2} alt="Food"/>
                    <img src={f3} alt="Group Picture"/>
                    <img src={f4} alt="Group Picture"/>
                    <img src={f5} alt="Group Picture"/>
                    <img src={f6} alt="Group Picture"/>
 
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Friendsgiving;

